const { buildIndustriesPath, buildIndustryDetailPath } = require('../utils/industries-data.cjs')

// Shared destinations and product identities; presentation and interaction stay in each component.
const navigationTargets = {
  support: '/faq',
  faq: '/faq#support-home-faq',
  about: '/about',
  news: '/news',
  administratorPlatform: 'https://www.anovator.com/admin/',
  apiDocumentation: 'https://docs.google.com/document/d/1o4EHv31S2ynU3pCBvoDD-ZT2-83mtEn1M_G43LZ55Vs/edit?usp=sharing'
}

function getProducts(language) {
  const products = [
    { name: 'P5', path: '/p5', image: '/static/images/products/p5-nav.png' },
    { name: language === 'ZH' ? 'P3' : 'A5', path: '/a5', image: '/static/images/A5.png' },
    { name: 'M3', path: '/m3', image: '/static/images/M3.png' },
    { name: language === 'ZH' ? 'P1' : 'M1', path: '/m1', image: '/static/images/M1.png' },
    { name: language === 'ZH' ? 'P0' : 'M0', path: '/m0', image: '/static/images/M0.png' }
  ]
  return language === 'ZH'
    ? [products[0], products[1], { name: 'K2', path: '/k2', image: '/static/images/product/k2/hero.png' }, products.find(product => product.path === '/m1')]
    : products
}

function createIndustryMenu(category, topics) {
  return {
    key: String(category.categoryId),
    label: category.title,
    position: category.position,
    path: buildIndustriesPath(category.categoryId),
    items: topics.map(topic => ({
      key: String(topic.id),
      label: topic.title,
      path: buildIndustryDetailPath(category.categoryId, topic.id)
    }))
  }
}

module.exports = { getProducts, navigationTargets, createIndustryMenu }
